import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { useActiveRoute } from '../../hooks/useActiveRoute.js';
import { BlockWrapper } from '../../ui-kit/BlockWrapper.js';
import { isVisibleItem } from '../../ui-kit/Sitemap/isVisibleItem.js';
import { UniBlock } from '../../UniBlock/UniBlock.js';
import { style } from '../../utils/style.js';
import { HeaderSubMenu } from './HeaderSubMenu.js';
import { HeaderTopMenu } from './HeaderTopMenu.js';
const BG_COLOR_TO_BLOCK_VERSION = {
    'bg-white': 'primary',
    transparent: 'transparent',
};
const HEADER_AREA_KEYS = ['all', 'header'];
export const Header = UniBlock(({ className, bgColor = 'bg-white', logo: customLogo = {}, version = BG_COLOR_TO_BLOCK_VERSION[bgColor], portal, header = {}, ...rest }) => {
    const { common, navigation } = getPageProperties(rest?.options?.page);
    const { navigationItems } = navigation;
    const { logo = {} } = common;
    const [, activeTopItem] = useActiveRoute(navigationItems);
    const { internetBankButton } = portal || {};
    const customProps = customLogo.image?.icon || customLogo.image?.src || customLogo?.title;
    const logoProps = customProps ? customLogo : logo;
    return (_jsx(BlockWrapper, { tag: "header", className: style('pt-m px-20', activeTopItem?.items?.length ? 'pb-m' : 'pb-lg', className), defaultPadding: "", version: version, ...rest, children: _jsxs("div", { className: "container", children: [_jsx("div", { className: "whitespace-nowrap", children: _jsx(HeaderTopMenu, { activeTopItem: activeTopItem, navigationItems: navigationItems?.filter(isVisibleItem(HEADER_AREA_KEYS)), version: version, headerData: { ...header, ...navigation }, search: common.search, bgColor: bgColor, logo: logoProps }) }), _jsx("div", { className: style('mt-s h-px bg-main-divider', getVersionStyle(version)) }), activeTopItem?.items?.length && (_jsx(HeaderSubMenu, { subItems: activeTopItem?.items?.filter(isVisibleItem(HEADER_AREA_KEYS)), version: version, internetBankButton: internetBankButton }))] }) }));
});
const getVersionStyle = (version) => (version === 'transparent' ? 'opacity-30' : '');
const getPageProperties = (page) => ({
    navigation: page?.navigation ?? {},
    common: page?.common ?? {},
});
//# sourceMappingURL=Header.js.map